var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadar3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_830_110)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#BEE3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#90CDF4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.5567 13.976C12.5561 14.3844 12.7277 14.7742 13.0289 15.0499C13.3301 15.3255 13.7335 15.4624 14.1402 15.427C14.547 15.3909 14.9203 15.1867 15.1687 14.8623C15.4179 14.5386 15.5187 14.1255 15.4479 13.723L21.3445 12.6845C21.5549 12.6484 21.7405 12.5249 21.8554 12.3441C21.9696 12.1639 22.003 11.9436 21.9462 11.738C21.1668 8.98282 19.0109 6.83094 16.2526 6.05675C16.0482 6.00002 15.8285 6.03205 15.6489 6.14418C15.4685 6.25698 15.3436 6.44053 15.3056 6.64943L14.2664 12.5422C13.8416 12.4655 13.4048 12.5809 13.0742 12.8579C12.7436 13.1349 12.554 13.5448 12.5567 13.976Z",
    fill: "#3182CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.0133 21.9979C15.9988 22.0006 17.9156 21.2664 19.3902 19.9375C20.8649 18.6086 21.7939 16.7792 21.9955 14.8048C22.0189 14.5926 21.9501 14.381 21.8058 14.2235C21.6636 14.0653 21.4599 13.9746 21.2468 13.9746C21.2021 13.9746 21.1573 13.9786 21.1133 13.9866C20.776 14.048 20.5222 14.3283 20.4948 14.67C20.3218 16.3113 19.5331 17.8264 18.2862 18.9095C17.0399 19.9921 15.4283 20.5621 13.7781 20.5047C12.1271 20.4467 10.5597 19.7659 9.39227 18.5986C8.22418 17.4312 7.54302 15.8647 7.48557 14.2148C7.42813 12.5649 7.99916 10.9551 9.08312 9.70962C10.1671 8.46417 11.6831 7.67598 13.326 7.50375C13.7247 7.46571 14.0246 7.12264 14.0079 6.72218C13.9912 6.32172 13.6633 6.00468 13.2626 6H13.1838C10.4335 6.29033 8.02581 7.97554 6.81292 10.4599C5.60006 12.9441 5.75235 15.8776 7.21631 18.223C8.67961 20.5685 11.2489 21.9961 14.0146 22L14.0133 21.9979Z",
    fill: "#3182CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9219 10.8563C13.1737 10.7655 13.3567 10.546 13.4008 10.2823C13.4389 10.0607 13.3761 9.83379 13.2298 9.66359C13.0896 9.49339 12.8812 9.39461 12.6608 9.39328C12.578 9.39328 12.4958 9.4073 12.4177 9.43466C10.8529 9.98129 9.67937 11.2935 9.31075 12.9087C8.94209 14.5239 9.43029 16.2153 10.6024 17.3859C11.7752 18.5566 13.4683 19.0431 15.0838 18.6734C16.6994 18.3036 18.0117 17.1296 18.5573 15.5652C18.6368 15.3409 18.6007 15.092 18.4618 14.8991C18.3202 14.6988 18.0898 14.5787 17.8447 14.5774C17.8 14.578 17.7552 14.582 17.7111 14.5894C17.4473 14.6334 17.2276 14.8163 17.1368 15.0679C16.7614 16.1419 15.8598 16.9475 14.7505 17.2003C13.6411 17.454 12.4791 17.1196 11.6743 16.3153C10.8695 15.511 10.5349 14.3497 10.788 13.2411C11.0418 12.1318 11.8481 11.2314 12.9219 10.8563Z",
    fill: "#3182CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_830_110",
    x: 0,
    y: 0,
    width: 28,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_830_110"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar3);
export default __webpack_public_path__ + "static/media/Radar3.9f7def031331218ac08e12c7480d5360.svg";
export { ForwardRef as ReactComponent };